import { Directive, ElementRef, OnInit, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { MatSnackBar } from '@angular/material';

@Directive({
  selector: '[CopyToClip]'
})
export class CopyToClipDirective implements OnInit {
  @Input('CopyToClip') text: string;
  constructor(private elRef: ElementRef,
    private clipboardService: ClipboardService, public snackBar: MatSnackBar
  ) { }
  ngOnInit(): void {
    this.elRef.nativeElement.style.cursor = 'pointer';
  }
  @HostListener('click') me(eventData: Event) {
    event.preventDefault();
  
    if (this.text == null) return;
    this.clipboardService.copyFromContent(this.text);
    this.snackBar.open("با موفقیت کپی شد", null, {
      duration: 2000,
    });
  }
}
